const decodeQueryTextParam = (search: string): string | undefined => {
  try {
    if (!search) {
      return search;
    }
    return decodeURIComponent(search.replace(/\+/g, ' '));
  } catch (_e) {
    return undefined;
  }
};

export default decodeQueryTextParam;
